import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { AppointmentData } from "../../config/bookingDataConfig"
import { capitalize, groupBy, lowerCase, upperCase } from "lodash"
// import moment from "moment"
import moment from "moment-timezone"
import { openToastify } from "../../store/actions/toastifyAction"
import {
  REDUX_CUSTOMER_DEFAULTS,
  REDUX_STORE_DEFAULTS,
  REDUX_TOASTIFY_DEFAULTS,
} from "../../store/config"
import { prettyFormat } from "@testing-library/react"
import {
  createBooking,
  getBookingSlots,
  getCustomersBySearch,
  getServicesData,
  getVehiclesData,
  updateBooking,
} from "../../../axios/api/apiModule"
import { bookingAction } from "../../store/actions/bookingAction"
import Loader from "../../../components/asserts/Spin.gif"
import {
  DropDownListComponent,
  MultiSelectComponent,
  DropDownList,
  MultiSelect,
  CheckBoxSelection,
  AutoCompleteComponent,
} from "@syncfusion/ej2-react-dropdowns"
import {
  ScheduleComponent,
  ViewsDirective,
  ViewDirective,
  Day,
  Week,
  WorkWeek,
  Month,
  Agenda,
  Inject,
  Resize,
  DragAndDrop,
  ResourcesDirective,
  ResourceDirective,
  TimelineViews,
} from "@syncfusion/ej2-react-schedule"
import { DataManager, Query, WebApiAdaptor } from "@syncfusion/ej2-data"
import "./CreateBookingStyle.css"
import GoogleMap from "../../data/modal/google_map/GoogleMap"
import CryptoJS from "crypto-js"
import {
  collection,
  addDoc,
  query,
  where,
  getDocs,
  updateDoc,
  arrayUnion,
  doc,
} from "firebase/firestore"
import { db } from "../../../firebase-config"
import { customersAction } from "../../store/actions/customersAction"
import { SendMsgEmail } from "../../data/modal/SendMsgEmail"
import _ from "lodash"
import Select from "react-select"

const CreateBooking = (props) => {
  const dispatch = useDispatch()
  const { data, onClick, isEdit } = props
  const _id = data?._id
  const [isData, setIsData] = useState({
    shortBookingId: data?.shortBookingId ?? "",
    firstName: data?.firstName ?? "",
    lastName: data?.lastName ?? "",
    phoneNumber: data?.phoneNumber ?? "",
    email: data?.email ?? "",
    bookingStatus: data?.bookingStatus ?? "confirmed",
    locationType: data?.locationType ?? "shop",
    location: data?.location ?? "",
    bookingDate: data?.bookingDate ?? new Date(),
    bookingSlot: data?.bookingSlot ?? moment().format("HH:mm"),
    adminAuthored: data?.adminAuthored ?? true,
    booking: data?.booking ?? [1],
    tax: data?.tax ?? 5,
    isWaterAvailable: data?.isWaterAvailable ?? true,
    isElectricityAvailable: data?.isElectricityAvailable ?? true,
    electricityBill: data?.electricityBill ?? 0,
    serviceTotal: data?.serviceTotal ?? 0,
    addonServiceTotal: data?.addonServiceTotal ?? 0,
    taxAmount: data?.taxAmount ?? 0,
    subTotal: data?.subTotal ?? 0,
    couponDiscountAmount: data?.couponDiscountAmount ?? 0,
    giftCardDiscountAmount: data?.giftCardDiscountAmount ?? 0,
    totalAmount: data?.totalAmount ?? 0,
  })
  const [allBookingSlot, setAllBookingSlot] = useState([])
  const [isSendStatus, setIsSendStatus] = useState({
    sendSMS: data?.bookingCnfMsg?.msgSend ?? false,
    sendEmail: data?.bookingCnfMsg?.emailSend ?? false,
  })
  let { shopBookingData, mobileBookingData, isBookingUpdated } = useSelector(
    (state) => state.bookingReducer,
  )
  const [customerListData, setCustomerListData] = useState([])
  const [isLoading, setisLoading] = useState(false)
  const [isPhoneLoading, setIsPhoneLoading] = useState(false)
  const [isBookingDate, setIsBookingDate] = useState(
    moment(isData.bookingDate).utc(),
  )
  const [isBookingTime, setIsBookingTime] = useState()

  const mobileTimeSlots = [
    "8:00am",
    "8:30am",
    "9:00am",
    "11:30am",
    "12:00pm",
    "12:30pm",
    "3:00pm",
    "3:30pm",
    "4:00pm",
  ]
  const shopTimeSlots = [
    "9:30am",
    "9:45am",
    "10:00am",
    "12:30pm",
    "12:45pm",
    "1:00pm",
    "4:00pm",
    "4:15pm",
    "4:30pm",
  ]

  const [vechicleList, setVchicleList] = useState([])
  const handleGetVehiles = async (locationType) => {
    try {
      const payload = {
        locationType,
      }
      const response = await getVehiclesData(payload)
      setVchicleList(response.data ?? [])
    } catch (error) {}
  }
  useEffect(() => {
    handleGetVehiles(isData.locationType)
  }, [isData.locationType])

  const [categoryListMap, setCategoryListMap] = useState({})
  const [servicesListMap, setServicesListMap] = useState({})
  const [addonServicesListMap, setAddonServicesListMap] = useState({})
  const handleGetServices = async (locationType, id, index) => {
    try {
      const payload = {
        locationType,
        id,
      }
      const response = await getServicesData(payload)
      setCategoryListMap((prev) => ({
        ...prev,
        [index]: response.data.category ?? [],
      }))
    } catch (error) {}
  }

  const hydrateCategoriesForEdit = async (
    vehicleId,
    service,
    bookingItem,
    index,
  ) => {
    try {
      // Fetch categories
      const res = await getServicesData({
        locationType: isData.locationType,
        id: vehicleId,
      })

      const categories = res.data.category ?? []

      // 3️⃣ Store categories
      setCategoryListMap((prev) => ({
        ...prev,
        [index]: categories,
      }))

      // 4️⃣ Resolve category by categoryId
      const selectedCategory = categories[service.categoryId]
      if (!selectedCategory) return

      // 5️⃣ Store services (packages)
      setServicesListMap((prev) => ({
        ...prev,
        [index]: selectedCategory.package ?? [],
      }))

      // 6️⃣ Resolve service (package) by packageId
      const selectedPackage = selectedCategory.package?.[service.packageId]

      if (!selectedPackage) return

      // 7️⃣ Store addons
      setAddonServicesListMap((prev) => ({
        ...prev,
        [index]: selectedPackage.addOns ?? [],
      }))
    } catch (err) {
      console.error("Edit hydration failed", err)
    }
  }

  useEffect(() => {
    if (!isEdit || !vechicleList.length || !isData.booking?.length) return

    isData.booking.forEach((bookingItem, index) => {
      const service = bookingItem.service
      if (!service?.serviceOption) return

      // 1️⃣ Find selected vehicle
      const selectedVehicle = vechicleList.find(
        (v) => v.serviceOption === service.serviceOption,
      )

      if (!selectedVehicle) return

      // 2️⃣ Fetch categories for this booking index
      hydrateCategoriesForEdit(selectedVehicle._id, service, bookingItem, index)
    })
  }, [isEdit, vechicleList, isData.booking])

  // Update Booking (START)
  const handleEditBookingApi = async () => {
    try {
      const response = await updateBooking({ ...isData })
      console.log(response)
      if (response.success) {
        dispatch(
          openToastify(
            "Booking Updated Successfully",
            REDUX_TOASTIFY_DEFAULTS.UPDATE_TOASTIFY_SUCCESS(),
          ),
        )
      }
    } catch (error) {
      console.log(JSON.stringify(error))
      dispatch(
        openToastify(
          error?.response?.data?.message || "Something Went Wrong",
          REDUX_TOASTIFY_DEFAULTS.UPDATE_TOASTIFY_ERROR(),
        ),
      )
    } finally {
      setisLoading(false)
    }
  }
  // Update Booking (END)

  const handleCreateBookingApi = async () => {
    setisLoading(true)
    try {
      const params = {
        ...isSendStatus,
        ...isData,
        isAppbooking: false,
      }
      console.log(params)
      const response = await createBooking(params)
      console.log(response)
      if (response.success) {
        dispatch(
          openToastify(
            "Booking Created Successfully",
            REDUX_TOASTIFY_DEFAULTS.UPDATE_TOASTIFY_SUCCESS(),
          ),
        )
      }
    } catch (error) {
      console.log(error)
      dispatch(
        openToastify(
          "Something Went Wrong",
          REDUX_TOASTIFY_DEFAULTS.UPDATE_TOASTIFY_ERROR(),
        ),
      )
      setisLoading(false)
    } finally {
      setisLoading(false)
    }
  }
  const handleSubmit = (e) => {
    e.preventDefault()

    setisLoading(true)
    if (isEdit) {
      handleEditBookingApi()
    } else {
      handleCreateBookingApi()
    }
  }

  useEffect(() => {
    if (isBookingDate) {
      booking({
        target: {
          value: moment(isBookingDate).format("yyyy-MM-DD"),
          name: "bookingDate",
        },
      })
    }
  }, [isBookingDate])
  useEffect(() => {
    if (isBookingTime || isData?.bookingSlot) {
      const formatedTime = moment
        .tz(
          `${isBookingTime ?? isData?.bookingSlot}`,
          "hh:mm:ss",
          "America/Vancouver",
        )
        .format("HH:mm")

      booking({ target: { value: formatedTime, name: "bookingSlot" } })
    }
  }, [isBookingTime])
  // Time Code (END)

  // Collection Booking Data Code (START)
  const booking = (event, index = null, info = "") => {
    const { name, value, type, lang } = event.target

    console.log("index", index, "name", name, "value", value)

    if (index !== null) {
      let updatedBooking

      if (name === "vehicle") {
        updatedBooking = isData.booking.map((item, i) =>
          i === index
            ? {
                ...item,
                service: {
                  ...item.service,
                  serviceOption: value?.serviceOption,
                  categoryName: "",
                  categoryId: null,
                  packageName: "",
                  packageId: null,
                  packageDescription: "",
                  packagePrice: 0,
                  packageSalePrice: 0,
                  packagePriceType: "fixed",
                  packagePriceRange: 1,
                },
                addonService: [],
                servicePrice: 0,
                addonTotalPrice: 0,
                totalPrice: 0,
              }
            : item,
        )

        handleGetServices(isData.locationType, value._id, index)
      } else if (name === "serviceType") {
        updatedBooking = isData.booking.map((item, i) =>
          i === index
            ? {
                ...item,
                service: {
                  ...item.service,
                  categoryName: value.name,
                  categoryId: value.categoryId,
                  packageName: "",
                  packageId: null,
                  packageDescription: "",
                  packagePrice: 0,
                  packageSalePrice: 0,
                  packagePriceType: "fixed",
                  packagePriceRange: 1,
                },
                addonService: [],
                servicePrice: 0,
                addonTotalPrice: 0,
                totalPrice: 0,
              }
            : item,
        )
        setServicesListMap((prev) => ({
          ...prev,
          [index]: value.package ?? [],
        }))
      } else if (name === "service") {
        updatedBooking = isData.booking.map((item, i) =>
          i === index
            ? {
                ...item,
                service: {
                  ...item.service,
                  packageName: value.name,
                  packageId: value.packageId,
                  packageDescription: value.description,
                  packagePrice: value.price,
                  packageSalePrice: value.salePrice,
                  packagePriceType: value.priceType,
                  packagePriceRange: 1,
                },
                addonService: [],
                servicePrice: value.salePrice,
                addonTotalPrice: 0,
                totalPrice: value.salePrice,
              }
            : item,
        )
        setAddonServicesListMap((prev) => ({
          ...prev,
          [index]: value.addOns ?? [],
        }))
      } else if (name === "addonService") {
        // const selectedAddons = Array.from(event.target.options)
        //   .filter((option) => option.selected)
        //   .map((option) => ({
        //     addonServiceId: parseInt(option.value, 10), // Assuming addonServiceId is an integer
        //     addonSericeName: option.getAttribute("addon-data-description"), // Assuming addonServiceName is the text of the option
        //     addonPrice: parseInt(option.getAttribute("addon-data-price"), 10), // You need to fetch addon price based on the selection
        //   }))
        const selectedAddons = value

        const addonServiceTotal = selectedAddons.reduce(
          (total, addon) => total + addon.addonSalePrice,
          0,
        )

        updatedBooking = isData.booking.map((item, i) =>
          i === index
            ? {
                ...item,
                addonService: selectedAddons,
                addonTotalPrice: addonServiceTotal,
                totalPrice: addonServiceTotal + item.service.packageSalePrice,
                servicePrice: item.service.packageSalePrice,
              }
            : item,
        )
      } else if (name === "servicePrice") {
        updatedBooking = isData.booking.map((item, i) =>
          i === index
            ? {
                ...item,
                service: {
                  ...item.service,
                  price: parseInt(value, 10),
                },
                servicePrice: parseInt(value, 10),
                totalPrice: parseInt(value, 10) + item.addonTotalPrice,
              }
            : item,
        )
        // setIsData((prevData) => ({
        //   ...prevData,
        //   addonService: selectedAddons,
        // }))
      } else if (name === "addonTotalPrice") {
        updatedBooking = isData.booking.map((item, i) =>
          i === index
            ? {
                ...item,
                addonTotalPrice: parseInt(value, 10),
                totalPrice: parseInt(value, 10) + item.service.price,
              }
            : item,
        )
        // setIsData((prevData) => ({
        //   ...prevData,
        //   addonService: selectedAddons,
        // }))
      } else if (name === "totalLength") {
        updatedBooking = isData.booking.map((item, i) =>
          i === index
            ? {
                ...item,
                totalLength: parseInt(value, 10),
                servicePrice: parseInt(value, 10) * item.service.price,
                totalPrice:
                  parseInt(value, 10) * item.service.price +
                  item.addonTotalPrice,
              }
            : item,
        )
      }

      const addonServiceTotal = updatedBooking.reduce(
        (total, booking) => total + booking.addonTotalPrice,
        0,
      )
      const serviceTotal = updatedBooking.reduce(
        (total, booking) => total + booking.servicePrice,
        0,
      )

      console.log(serviceTotal, "price", addonServiceTotal)
      console.log("updatedBooking========>", updatedBooking)

      calculatePricing({ target: { value: serviceTotal } }, "serviceTotal")
      calculatePricing(
        { target: { value: addonServiceTotal } },
        "addonServiceTotal",
      )

      setIsData((prevData) => ({
        ...prevData,
        booking: updatedBooking,
        addonServiceTotal,
        serviceTotal,
      }))
    } else if (name === "bookingTimeSlot") {
      setIsData((prevData) => ({
        ...prevData,
        [name]: parseInt(value, 10),
      }))
    } else if (name === "bookingDate") {
      setIsData((prevData) => ({
        ...prevData,
        [name]: value,
      }))
    } else if (type === "number" || lang === "number") {
      setIsData((prevData) => ({
        ...prevData,
        [name]: parseInt(value, 10),
      }))
    } else if (lang === "boolean") {
      setIsData((prevData) => ({
        ...prevData,
        [name]: value === "true",
      }))
    } else {
      console.log("elese")
      setIsData((prevData) => ({
        ...prevData,
        [name]: value,
      }))
    }
    if (isData.email === "" && name === "location") {
      setIsData((prevData) => ({
        ...prevData,
        email: "info@boostmobiledetailing.ca",
      }))
    }
  }
  const handleAddonServiceChange = (e, index) => {
    const addons = addonServicesListMap[index] ?? []

    const selectedAddons = e.value.map((id) => {
      const addonIndex = addons.findIndex((a) => a.name === id)

      const addon = addons[addonIndex]
      return {
        addonServiceId: addonIndex,
        addonServiceName: addon.name,
        addonPrice: addon.price,
        addonSalePrice: addon.salePrice,
        addonPriceType: addon.priceType,
        addonPriceRange: 1,
      }
    })

    booking(
      {
        target: {
          name: "addonService",
          value: selectedAddons,
        },
      },
      index,
    )
  }
  //All Calculation
  const calculatePricing = (e, name) => {
    if (name === "isElectricityAvailable") {
      const electricityValue = e.target.value === "false" ? 15 : 0
      console.log(
        "consoling",
        typeof e.target.value,
        name,
        electricityValue,
        e.target.value,
      )

      setIsData((prevData) => {
        const subTotal = prevData.subTotal ?? 0
        const taxAmount = prevData.taxAmount ?? 0
        const addonTotalPrice = prevData.addonTotalPrice ?? 0
        const couponDiscountAmount = prevData.couponDiscountAmount ?? 0
        const giftCardDiscountAmount = prevData.giftCardDiscountAmount ?? 0

        // const couponDiscountAmount = (subTotal * couponDiscountPercentage) / 100

        const totalAmount =
          subTotal +
          taxAmount +
          addonTotalPrice -
          couponDiscountAmount -
          giftCardDiscountAmount +
          electricityValue

        return {
          ...prevData,
          isElectricityAvailable: e.target.value === "true",
          electricityBill: electricityValue,
          totalAmount,
        }
      })
    } else if (name === "serviceTotal") {
      const serviceTotalNew = parseFloat(e.target.value)
      setIsData((prev) => {
        const newServiceTotal = serviceTotalNew
        const newSubTotal = newServiceTotal + prev.addonServiceTotal

        const couponDiscountAmount = prev.couponDiscountAmount ?? 0
        const giftCardDiscountAmount = prev.giftCardDiscountAmount ?? 0
        const electricityBill = prev.electricityBill ?? 0
        const taxRate = prev.tax ?? 0

        // Calculate the coupon discount amount based on the percentage
        // const couponDiscountAmount =
        //   (newSubTotal * couponDiscountPercentage) / 100

        // Calculate the new tax amount
        const newTaxAmount = Number(
          (
            ((newSubTotal - couponDiscountAmount - giftCardDiscountAmount) *
              taxRate) /
            100
          ).toFixed(2),
        )

        // Calculate the new total amount
        const newTotalAmount = (
          newSubTotal +
          newTaxAmount -
          couponDiscountAmount -
          giftCardDiscountAmount +
          electricityBill
        ).toFixed(2)

        return {
          ...prev,
          serviceTotal: newServiceTotal,
          subTotal: newSubTotal,
          taxAmount: newTaxAmount,
          totalAmount: Number(newTotalAmount),
        }
      })
    } else if (name === "addonServiceTotal") {
      const addonTotalPriceNew = parseFloat(e.target.value)
      setIsData((prev) => {
        const newAddonTotalPrice = addonTotalPriceNew
        const newSubTotal = prev.serviceTotal + newAddonTotalPrice

        const couponDiscountAmount = prev.couponDiscountAmount ?? 0
        const giftCardDiscountAmount = prev.giftCardDiscountAmount ?? 0
        const electricityBill = prev.electricityBill ?? 0
        const taxRate = prev.tax ?? 0

        // Calculate the coupon discount amount based on the percentage
        // const couponDiscountAmount =
        //   (newSubTotal * couponDiscountPercentage) / 100

        // Calculate the new tax amount
        const newTaxAmount = Number(
          (
            ((newSubTotal - couponDiscountAmount - giftCardDiscountAmount) *
              taxRate) /
            100
          ).toFixed(2),
        )

        // Calculate the new total amount
        const newTotalAmount = (
          newSubTotal +
          newTaxAmount -
          couponDiscountAmount -
          giftCardDiscountAmount +
          electricityBill
        ).toFixed(2)

        return {
          ...prev,
          addonServiceTotal: newAddonTotalPrice,
          subTotal: newSubTotal,
          taxAmount: newTaxAmount,
          totalAmount: Number(newTotalAmount),
        }
      })
    } else if (name === "couponDiscountAmount") {
      const newCouponDiscountPercentage = parseFloat(e.target.value || 0)

      setIsData((prev) => {
        const couponDiscountAmount =
          (prev.subTotal * newCouponDiscountPercentage) / 100
        const newTaxAmount = Number(
          (
            ((prev.subTotal -
              couponDiscountAmount -
              prev.giftCardDiscountAmount) *
              prev.tax) /
            100
          ).toFixed(2),
        )
        const newTotalAmount = (
          prev.subTotal +
          newTaxAmount -
          couponDiscountAmount -
          prev.giftCardDiscountAmount +
          prev.electricityBill
        ).toFixed(2)

        return {
          ...prev,
          couponDiscountAmount: couponDiscountAmount,
          totalAmount: Number(newTotalAmount),
          taxAmount: newTaxAmount,
        }
      })
    } else if (name === "giftCardDiscountAmount") {
      const newGiftCardDiscountAmount = parseFloat(e.target.value || 0)
      setIsData((prev) => {
        // Convert couponDiscountAmount from percentage to absolute amount
        const couponDiscountAmount = prev.couponDiscountAmount

        const newTaxAmount = Number(
          (
            ((prev.subTotal -
              couponDiscountAmount -
              newGiftCardDiscountAmount) *
              prev.tax) /
            100
          ).toFixed(2),
        )

        const newTotalAmount = (
          prev.subTotal +
          newTaxAmount -
          couponDiscountAmount -
          newGiftCardDiscountAmount +
          prev.electricityBill
        ).toFixed(2)

        return {
          ...prev,
          giftCardDiscountAmount: newGiftCardDiscountAmount,
          totalAmount: Number(newTotalAmount),
          taxAmount: newTaxAmount,
        }
      })
    } else if (name === "tax") {
      const newTax = parseInt(e.target.value)
      setIsData((prev) => {
        // Convert couponDiscountAmount from percentage to absolute amount
        const couponDiscountAmount =
          (prev.subTotal * prev.couponDiscountAmount) / 100

        const newTaxAmount = Number(
          (
            ((prev.subTotal -
              couponDiscountAmount -
              prev.giftCardDiscountAmount) *
              newTax) /
            100
          ).toFixed(2),
        )

        const newTotalAmount = Number(
          (
            prev.subTotal +
            newTaxAmount -
            couponDiscountAmount -
            prev.giftCardDiscountAmount +
            prev.electricityBill
          ).toFixed(2),
        )

        return {
          ...prev,
          tax: newTax,
          taxAmount: newTaxAmount,
          totalAmount: newTotalAmount,
        }
      })
    } else {
      console.log("Select a valid option !")
    }
  }

  const handleAddressSelect = (address) => {
    if (isData.location !== address) {
      console.log("Selected Address: ", address)
      booking({ target: { name: "location", value: address ?? "" } })
    }
  }
  // Collection Booking Data Code (End)

  useEffect(() => {
    console.log(isEdit, "data=====", isData)
  }, [isData])

  const removeBooking = (indexToRemove) => {
    const updatedBooking = isData.booking.filter(
      (_, index) => index !== indexToRemove,
    )

    // Calculate new serviceTotal and addonServiceTotal
    const newServiceTotal = updatedBooking.reduce(
      (total, booking) => total + booking.servicePrice,
      0,
    )
    const newAddonTotalPrice = updatedBooking.reduce(
      (total, booking) => total + booking.addonTotalPrice,
      0,
    )

    // Calculate the coupon discount amount based on the percentage
    const couponDiscountAmount =
      (newServiceTotal * isData.couponDiscountAmount) / 100

    // Calculate new tax amount
    const newTaxAmount = Number(
      (
        ((newServiceTotal +
          newAddonTotalPrice -
          couponDiscountAmount -
          isData.giftCardDiscountAmount) *
          isData.tax) /
        100
      ).toFixed(2),
    )

    // Calculate new total amount
    const newTotalAmount = Number(
      (
        newServiceTotal +
        newAddonTotalPrice +
        newTaxAmount -
        couponDiscountAmount -
        isData.giftCardDiscountAmount +
        isData.electricityBill
      ).toFixed(2),
    )

    setIsData((prevData) => ({
      ...prevData,
      booking: updatedBooking,
      serviceTotal: newServiceTotal,
      addonServiceTotal: newAddonTotalPrice,
      subTotal: newServiceTotal + newAddonTotalPrice,
      taxAmount: newTaxAmount,
      totalAmount: newTotalAmount,
    }))
  }

  const BookingStatus = [
    {
      status: "pending",
    },
    {
      status: "confirmed",
    },
    {
      status: "processing",
    },
    {
      status: "cancelled",
    },
    {
      status: "completed",
    },
  ]
  // Custom template function to include both service name and price
  const customTemplate = (data) => (
    <div className="space-x-2">
      <span className="service-name">{data.name}</span>
      <span className="service-price">${data.price}</span>
    </div>
  )

  useEffect(() => {
    console.log(customerListData, "customerListData")
  }, [])
  const customerFields = { value: "phoneNumber", groupBy: "name" }
  const filterData = ["Contains", "StartsWith", "EndsWith"]
  const [filterType, setFilterType] = useState("Contains")
  //set the value to header template
  const headerTemplate = () => {
    return (
      <div className="header">
        {" "}
        <span>Photo</span> <span className="columnHeader">Employee Info</span>
      </div>
    )
  }
  //set the value to item template
  const itemTemplate = (data) => {
    if (!data || !data.phoneNumber || !data.name) {
      return null
    }
    return (
      <div className="autocomplete-item overflow-hidden border-y-1 border-yellow-dark flex flex-col">
        <div className="flex flex-row">
          <span>Name:</span>
          <span>
            {data.name} ({data.phoneNumber})
          </span>
        </div>
      </div>
    )
  }

  // Function to find customer by phone number
  const findCustomerByPhoneNumber = async (phoneNumber) => {
    setIsPhoneLoading(true)
    try {
      const payload = {
        search: phoneNumber,
      }
      const response = await getCustomersBySearch(payload)
      if (response.success) {
        setCustomerListData(response.data || [])
      }
      console.log(response)
    } catch (error) {
      console.log(error)
    } finally {
      setIsPhoneLoading(false)
    }
  }
  // const onChange = (value) => {
  //   if (!value) {
  //     return
  //   }
  //   // Remove +1, special characters, symbols, and spaces from the phone number
  //   const cleanedValue = value?.replace(/\+1|[^0-9]/g, "")
  //   setTimeout(() => {
  //     findCustomerByPhoneNumber(cleanedValue)
  //   }, 1000)

  //   // if (customer) {
  //   //   booking({
  //   //     target: { name: "firstName", value: customer?.firstName ?? "" },
  //   //   })
  //   //   booking({ target: { name: "email", value: customer?.email ?? "" } })
  //   //   booking({
  //   //     target: { name: "phoneNumber", value: customer?.phoneNumber ?? "" },
  //   //   })
  //   //   booking({ target: { name: "location", value: customer?.address ?? "" } })
  //   // } else {
  //   //   booking({
  //   //     target: {
  //   //       name: "phoneNumber",
  //   //       value: cleanedValue ?? "",
  //   //       type: "number",
  //   //     },
  //   //   })
  //   // }
  // }

  const [phoneInput, setPhoneInput] = useState("")
  const [selectedOption, setSelectedOption] = useState(null)
  const [options, setOptions] = useState([])
  const normalizePhone = (text) => {
    if (!text) return ""

    // remove everything except numbers
    let digits = text.replace(/\D/g, "")

    // remove leading 1 if 11 digits starting with 1
    if (digits.length === 11 && digits.startsWith("1")) {
      digits = digits.substring(1)
    }

    // limit to 10 digits only
    if (digits.length > 10) {
      digits = digits.substring(0, 10)
    }

    return digits
  }
  const handleInputChange = (text) => {
    const normalized = normalizePhone(text || isData.phoneNumber)

    setPhoneInput(text)

    if (!normalized) return

    findCustomerByPhoneNumber(normalized)
  }
  useEffect(() => {
    if (isData.phoneNumber) {
      findCustomerByPhoneNumber(isData.phoneNumber)
      const newOption = {
        label: `${isData.firstName} - ${isData.phoneNumber}`,
        value: isData.phoneNumber,
        name: isData.firstName,
        email: isData.email,
      }
      setSelectedOption(newOption)
    }
  }, [])

  useEffect(() => {
    const mapped = customerListData.map((val) => ({
      label: `${val.name} - ${val.phoneNumber}`,
      value: normalizePhone(val.phoneNumber),
      name: val.name,
      email: val.email,
    }))

    const normalized = normalizePhone(phoneInput)

    // if API returned customers
    if (mapped.length > 0) {
      setOptions(mapped)
      return
    }

    // if no customer found and phone complete
    if (normalized.length === 10) {
      const newOption = {
        label: `Unknown - ${normalized}`,
        value: normalized,
        name: normalized,
        email: "info@boostmobiledetailng.ca",
      }

      setOptions([newOption])
    } else {
      // if typing / deleting
      setOptions([])
    }
  }, [customerListData, phoneInput])
  const handleSelect = (data) => {
    setSelectedOption(data)
    booking({
      target: { name: "firstName", value: data?.name ?? "" },
    })
    booking({ target: { name: "email", value: data?.email ?? "" } })
    booking({
      target: { name: "phoneNumber", value: Number(data?.value) ?? "" },
    })
    setPhoneInput(data?.value)
    // booking({ target: { name: "location", value: customer?.address ?? "" } })
  }
  return (
    <>
      <div className="fixed inset-0 z-30 bg-black bg-opacity-45 backdrop-blur-sm">
        <div className="flex h-full justify-center items-center">
          <div className="bg-white lg:h-[95%] auto h-[80%] lg:w-[75%] w-[95%] rounded flex flex-col relative">
            <div
              className="flex justify-end -mt-2 -mr-2 cursor-pointer"
              onClick={onClick}
            >
              <svg
                className="size-6 bg-white rounded border border-black"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18 18 6M6 6l12 12"
                />
              </svg>
            </div>
            <div className="px-[5%] py-5 overflow-y-scroll">
              <h1>Informations:</h1>
              <div className="flex flex-col items-start justify-between h-[42rem]">
                <form
                  onSubmit={handleSubmit}
                  className="sm:space-y-0 space-y-5 mx-auto grid-flow-row sm:grid lg:grid-cols-7 gap-4 py-4 w-full"
                >
                  {/* Select Location: */}
                  <div className="flex flex-col col-span-2">
                    <span className="text-sm">
                      Select Location:
                      <span className="text-red-500">*</span>
                    </span>
                    <select
                      name="locationType"
                      id="location"
                      className="h-10 rounded-md px-2 text-black border border-black"
                      value={isData.locationType}
                      onChange={booking}
                      required
                    >
                      <option value="">Select Location</option>
                      {AppointmentData.map((item) => (
                        <option
                          key={item.locationRole}
                          value={lowerCase(item.locationRole)}
                        >
                          {item.displayName}
                        </option>
                      ))}
                    </select>
                  </div>
                  {/* Booking Status: */}
                  <div className="flex flex-col">
                    <span className="text-sm">
                      Booking Status:
                      <span className="text-red-500">*</span>
                    </span>
                    <select
                      name="bookingStatus"
                      id="bookingStatus"
                      className="h-10 rounded-md px-2 text-black border border-black"
                      value={isData.bookingStatus}
                      onChange={booking}
                      required
                    >
                      {BookingStatus.map((item) => (
                        <option key={item.status} value={item.status}>
                          {capitalize(item.status)}
                        </option>
                      ))}
                    </select>
                  </div>
                  {/* Booking Date: */}
                  <div className="flex flex-col col-span-2">
                    <span className="text-sm">
                      Booking Date:
                      <span className="text-red-500">*</span>
                    </span>
                    <input
                      type="date"
                      className="h-10 rounded-md px-2 text-black border border-black"
                      required
                      value={
                        moment
                          .tz(
                            isData?.bookingDate,
                            "YYYY-MM-DD",
                            "America/Vancouver",
                          )
                          .format("yyyy-MM-DD") ?? isBookingDate
                      }
                      name="bookingDate"
                      onChange={(e) => setIsBookingDate(e.target.value)}
                      // onChange={booking}
                      // min={isEdit ? "" : formatDate(Date())}
                    />
                  </div>
                  {/* Booking Slot: */}
                  <div className="flex flex-col col-span-2">
                    <span className="text-sm">
                      Booking Slot: <span className="text-red-500">*</span>
                    </span>
                    {/* <select
                      name="bookingSlot"
                      id="bookingSlot"
                      className="h-10 rounded-md px-2 text-black border border-black"
                      value={isData.bookingSlot}
                      lang="number"
                      onChange={booking}
                      required
                    >
                      <option value="">Select Slot</option>
                      {allBookingSlot.map((item) => (
                        <option
                          key={item.id}
                          value={item.id}
                          className={` ${
                            item.isSlot ? "bg-red-100" : "bg-green-100"
                          } `}
                        >
                          {moment(item.timeSlot).format("hh:mm A")}
                        </option>
                      ))}
                    </select> */}
                    <input
                      type="time"
                      id="bookingTimeSlot"
                      className="h-10 rounded-md px-2 text-black border border-black"
                      name="bookingTimeSlot"
                      // step="60"
                      value={
                        moment
                          .tz(isData?.bookingSlot, "HH:mm", "America/Vancouver")
                          .format("HH:mm:ss") || isBookingTime
                      }
                      onChange={(e) => setIsBookingTime(e.target.value)}
                      required
                    />
                  </div>
                  <hr className="col-span-7 bg-slate-400 h-[0.2rem]" />
                  <div className="flex flex-col col-span-7">
                    {isData.booking?.map((value, index) => {
                      return (
                        <div className="flex justify-between space-y-4">
                          <div className="flex lg: flex-col space-y-4 mb-4 w-full">
                            <div className="flex flex-wrap justify-between space-y-2 md:space-y-0">
                              <div className="flex flex-col w-[9rem]">
                                <span className="text-sm">
                                  Select Vehicle:
                                  <span className="text-red-500">*</span>
                                </span>
                                <select
                                  name="vehicle"
                                  id="vehicle"
                                  className="h-10 rounded-md px-2 text-black border border-black"
                                  value={value?.service?.serviceOption}
                                  onChange={(e) => {
                                    const selectedServ = vechicleList.find(
                                      (serv) => {
                                        return (
                                          e.target.value === serv.serviceOption
                                        )
                                      },
                                    )
                                    booking(
                                      {
                                        target: {
                                          name: e.target.name,
                                          value: selectedServ,
                                        },
                                      },
                                      index,
                                    )
                                  }}
                                  required
                                  // disabled
                                >
                                  <option value="">Select Vehicle</option>
                                  {vechicleList.map((staff) => (
                                    <option
                                      key={staff._id}
                                      value={staff.serviceOption}
                                    >
                                      {staff.serviceOption}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="flex flex-col w-[16rem]">
                                <span className="text-sm">
                                  Select Service Type:
                                  <span className="text-red-500">*</span>
                                </span>
                                <select
                                  name="serviceType"
                                  id="serviceType"
                                  className="h-10 rounded-md px-2 text-black border border-black"
                                  value={value?.service?.categoryName}
                                  onChange={(e) => {
                                    const selectedCatInx = (
                                      categoryListMap[index] ?? []
                                    ).findIndex((serv) => {
                                      return e.target.value === serv.name
                                    })

                                    const selectedServ =
                                      categoryListMap[index][selectedCatInx]
                                    booking(
                                      {
                                        target: {
                                          name: e.target.name,
                                          value: {
                                            ...selectedServ,
                                            categoryId: selectedCatInx,
                                          },
                                        },
                                      },
                                      index,
                                    )
                                  }}
                                  required
                                >
                                  <option value="">Select Service Type</option>
                                  {(categoryListMap[index] ?? []).map(
                                    (service) => (
                                      <option
                                        key={service._id}
                                        value={service.name}
                                      >
                                        {service.name}
                                      </option>
                                    ),
                                  )}
                                </select>
                              </div>
                              <div className="flex flex-col w-[16rem]">
                                <span className="text-sm">
                                  Select Service:
                                  <span className="text-red-500">*</span>
                                </span>
                                <select
                                  name="service"
                                  id="service"
                                  className="h-10 rounded-md px-2 text-black border border-black"
                                  value={value?.service?.packageName}
                                  onChange={(e) => {
                                    const selectedServInx = (
                                      servicesListMap[index] ?? []
                                    ).findIndex((serv) => {
                                      return e.target.value === serv.name
                                    })

                                    const selectedServ =
                                      servicesListMap[index][selectedServInx]
                                    booking(
                                      {
                                        target: {
                                          name: e.target.name,
                                          value: {
                                            ...selectedServ,
                                            packageId: selectedServInx,
                                          },
                                        },
                                      },
                                      index,
                                    )
                                  }}
                                  required
                                >
                                  <option value="">Select Service</option>
                                  {(servicesListMap[index] ?? []).map(
                                    (service) => (
                                      <option
                                        key={service._id}
                                        value={service.name}
                                      >
                                        {service.name}-${service.salePrice}
                                      </option>
                                    ),
                                  )}
                                </select>
                              </div>
                              <div className="flex flex-col w-[9rem]">
                                <span className="text-sm">
                                  Service Price:
                                  <span className="text-red-500">*</span>
                                </span>
                                <div className="relative h-[42px]">
                                  <span className="absolute left-3 top-1/2 -translate-y-1/2 text-black">
                                    $
                                  </span>

                                  <input
                                    type="number"
                                    className="h-10 rounded-md pl-6 text-black border border-black"
                                    placeholder="0.00"
                                    required
                                    min={0}
                                    value={
                                      value?.service?.packageSalePrice ?? 0
                                    }
                                    name="servicePrice"
                                    onChange={(e) => booking(e, index)}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="flex flex-wrap md:space-x-4 space-y-2 md:space-y-0">
                              <div className="flex flex-col w-[18rem]">
                                <span className="text-sm">
                                  (Click Ctrl) Select Addon :
                                </span>
                                {/* <select
                                  name="addonService"
                                  id="addonService"
                                  className="md:h-16 py-2 space-y-1 rounded-md px-2 text-black border border-black"
                                  value={value?.addonService?.map(
                                    (addon) => addon.addonServiceId
                                  )}
                                  onChange={(e) => booking(e, index)}
                                  multiple
                                >
                                  {AppointmentData.find((location) =>
                                    location.locationRole === data?.locationType
                                      ? upperCase(data?.locationType)
                                      : isData?.locationType
                                  )
                                    ?.staff.find((staff) =>
                                      staff.type === value?.service?.vehicleType
                                        ? value?.service?.vehicleType
                                        : isData.vehicle
                                    )
                                    ?.servicesList.find((service) =>
                                      service.type ===
                                      value?.service?.serviceName
                                        ? value?.service?.serviceName
                                        : isData.serviceType
                                    )
                                    ?.services.find(
                                      (service) =>
                                        service?.id ===
                                          value?.service.serviceId ??
                                        isData.addonService
                                    )
                                    ?.addonService.map((addon) => (
                                      <option
                                        key={addon.id}
                                        value={addon.id}
                                        addon-data-price={addon.price}
                                        addon-data-description={
                                          addon.serviceDisplayName
                                        }
                                      >
                                        {addon.serviceDisplayName} $
                                        {addon.price}
                                      </option>
                                    ))}
                                </select> */}
                                <MultiSelectComponent
                                  id="addonService"
                                  name="addonService"
                                  placeholder="Choose Add-on Services"
                                  className="md:h-16 py-2 space-y-1 rounded-md px-2 text-black border border-black"
                                  // allowObjectBinding={true}
                                  // allowCustomValue={true}
                                  style={{ width: "100%" }}
                                  value={value?.addonService?.map(
                                    (addon) => addon.addonServiceName,
                                  )}
                                  dataSource={addonServicesListMap[index] ?? []}
                                  fields={{
                                    text: "name",
                                    value: "name",
                                  }}
                                  mode="CheckBox"
                                  change={(e) =>
                                    handleAddonServiceChange(e, index)
                                  }
                                  itemTemplate={customTemplate} // Use the custom template for rendering
                                >
                                  <Inject services={[CheckBoxSelection]} />
                                </MultiSelectComponent>
                              </div>
                              <div className="flex flex-col w-[9rem]">
                                <span className="text-sm">
                                  Enter Addon Price:
                                  {/* <span className="text-red-500">*</span> */}
                                </span>
                                <input
                                  type="number"
                                  className="h-10 rounded-md px-2 text-black border border-black"
                                  placeholder="$ 0.00"
                                  min={0}
                                  required
                                  value={value?.addonTotalPrice ?? "$ 0.00"}
                                  name="addonTotalPrice"
                                  onChange={(e) => booking(e, index)}
                                />
                              </div>
                              <div className="flex flex-col w-[9rem]">
                                <span className="text-sm">
                                  Enter SubTotal Price:
                                  {/* <span className="text-red-500">*</span> */}
                                </span>
                                <input
                                  type="number"
                                  className="h-10 rounded-md px-2 text-black border border-black"
                                  placeholder="$ 0.00"
                                  min={0}
                                  required
                                  value={value.totalPrice}
                                  name="totalPrice"
                                  onChange={(e) => booking(e, index)}
                                  disabled
                                />
                              </div>
                              <div className="flex flex-col w-[9rem]">
                                {value.pricingType === "rate" ? (
                                  <>
                                    <span className="text-sm">
                                      Lenght/ No of Seats:
                                      <span className="text-red-500">*</span>
                                    </span>
                                    <input
                                      type="number"
                                      className="h-10 rounded-md px-2 text-black border border-black"
                                      placeholder="0"
                                      min={0}
                                      required
                                      value={value.totalLength}
                                      name="totalLength"
                                      onChange={(e) => booking(e, index)}
                                    />
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                            <hr />
                          </div>
                          <div
                            className="flex justify-end items-center bg-red-100 h-40 cursor-pointer ml-1"
                            onClick={() => {
                              removeBooking(index)
                            }}
                          >
                            <svg
                              className="size-6 text-red-600"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="1.5"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                              />
                            </svg>
                          </div>
                        </div>
                      )
                    })}
                  </div>

                  {/* Select for isWaterAvailable */}
                  <div className="flex flex-col col-span-2">
                    <label htmlFor="isWaterAvailable" className="text-sm">
                      Water Availability:<span className="text-red-500">*</span>
                    </label>
                    <select
                      id="isWaterAvailable"
                      name="isWaterAvailable"
                      value={isData.isWaterAvailable} // Ensure to convert boolean to string
                      onChange={booking}
                      className="h-10 rounded-md px-2 text-black border border-black"
                      lang="boolean"
                      disabled={isData.locationType !== "mobile"}
                      required
                    >
                      <option value="">Select W-Access</option>
                      <option value={true}>Not - Sure</option>
                      <option value={false}>Not Available</option>
                    </select>
                  </div>

                  {/* Select for isElectricityAvailable */}
                  <div className="flex flex-col col-span-2">
                    <label htmlFor="isElectricityAvailable" className="text-sm">
                      Electricity Availability:
                      <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="isElectricityAvailable"
                      name="isElectricityAvailable"
                      value={isData.isElectricityAvailable} // Ensure to convert boolean to string
                      onChange={(e) => {
                        calculatePricing(e, "isElectricityAvailable")
                      }}
                      className="h-10 rounded-md px-2 text-black border border-black"
                      lang="boolean"
                      disabled={isData.locationType !== "mobile"}
                      required
                    >
                      <option value="">Select E-Access</option>
                      <option value={true}>Not - Sure</option>
                      <option value={false}>Not Available</option>
                    </select>
                  </div>

                  {/* Service Total */}
                  <div className="flex flex-col">
                    <span className="text-sm">Service Total:</span>
                    <input
                      type="number"
                      className="h-10 rounded-md px-2 text-black border border-black"
                      placeholder="Service Total"
                      value={isData.serviceTotal}
                      min={0}
                      name="serviceTotal"
                      onChange={(e) => {
                        calculatePricing(e, "serviceTotal")
                      }}
                    />
                  </div>

                  {/* Addon Service Total */}
                  <div className="flex flex-col">
                    <span className="text-sm">Addon Total:</span>
                    <input
                      type="number"
                      className="h-10 rounded-md px-2 text-black border border-black"
                      placeholder="Addon Service Total"
                      value={isData.addonServiceTotal}
                      min={0}
                      name="addonServiceTotal"
                      onChange={(e) => {
                        calculatePricing(e, "addonServiceTotal")
                      }}
                    />
                  </div>

                  {/* Subtotal */}
                  <div className="flex flex-col">
                    <span className="text-sm">Subtotal:</span>
                    <input
                      type="number"
                      step="0.01"
                      className="h-10 rounded-md px-2 text-black border border-black"
                      placeholder="Subtotal"
                      value={isData.subTotal}
                      min={0}
                      name="subTotal"
                      onChange={booking}
                      disabled
                    />
                  </div>

                  {/* Coupon Discount Amount */}
                  <div className="flex flex-col">
                    <span className="text-sm">
                      Coupon Discount -${isData.couponDiscountAmount || 0}:
                    </span>
                    <input
                      type="text" // Changed to text to allow the "%" symbol
                      inputMode="decimal" // Still triggers the numeric keypad on mobile devices
                      className="h-10 rounded-md px-2 text-black border border-black"
                      placeholder="Coupon Discount Amount"
                      name="couponDiscountAmount"
                      value={
                        isData.subTotal && isData.couponDiscountAmount
                          ? `${Number(((isData.couponDiscountAmount / isData.subTotal) * 100).toFixed(2))}`
                          : ""
                      }
                      onChange={(e) => {
                        const cleanValue = e.target.value.replace(
                          /[^0-9.]/g,
                          "",
                        )
                        const modifiedEvent = {
                          ...e,
                          target: {
                            ...e.target,
                            name: e.target.name,
                            value: cleanValue, // Sending only clean numbers (e.g., "15.5")
                          },
                        }
                        calculatePricing(modifiedEvent, "couponDiscountAmount")
                      }}
                    />
                  </div>

                  {/* Gift Card Discount Amount */}
                  <div className="flex flex-col">
                    <span className="text-sm">Gift Card Amount:</span>
                    <input
                      type="number"
                      step="0.01"
                      className="h-10 rounded-md px-2 text-black border border-black"
                      placeholder="Gift Card Discount Amount"
                      value={isData.giftCardDiscountAmount || ""}
                      min={0}
                      name="giftCardDiscountAmount"
                      onChange={(e) => {
                        calculatePricing(e, "giftCardDiscountAmount")
                      }}
                    />
                  </div>

                  {/* Tax */}
                  <div className="flex flex-col">
                    <span className="text-sm">
                      Enter TAX:
                      <span className="text-red-500">*</span>
                    </span>
                    <input
                      type="number"
                      className="h-10 rounded-md px-2 text-black border border-black"
                      placeholder="tax"
                      min={0}
                      required
                      value={isData.tax ?? 5}
                      name="tax"
                      onChange={(e) => {
                        calculatePricing(e, "tax")
                      }}
                      disabled
                    />
                  </div>

                  {/* Tax Amount */}
                  <div className="flex flex-col">
                    <span className="text-sm">Tax Amount:</span>
                    <input
                      type="number"
                      step="0.01"
                      className="h-10 rounded-md px-2 text-black border border-black"
                      placeholder="Tax Amount"
                      value={isData.taxAmount}
                      name="taxAmount"
                      onChange={booking}
                      disabled
                    />
                  </div>

                  {/* Electricity Bill */}
                  <div className="flex flex-col">
                    <span className="text-sm">Electricity Bill:</span>
                    <input
                      type="number"
                      className="h-10 rounded-md px-2 text-black border border-black"
                      placeholder="Electricity Bill"
                      value={isData.electricityBill}
                      min={0}
                      name="electricityBill"
                      onChange={booking}
                      disabled
                    />
                  </div>

                  {/* Total Amount */}
                  <div className="flex flex-col col-span-2">
                    <span className="text-sm">Total Amount:</span>
                    <input
                      type="number"
                      step="0.01"
                      className="h-10 rounded-md px-2 text-black border border-black"
                      placeholder="Total Amount"
                      value={isData.totalAmount}
                      min={0}
                      name="totalAmount"
                      onChange={booking}
                      disabled
                    />
                  </div>

                  <div className="flex flex-col justify-center col-span-7">
                    {isData.booking?.length < 2 && (
                      <span
                        className="h-10 w-[15rem] rounded-md px-2 text-white border border-y-yellow-light bg-yellow-light_medium shadow shadow-black flex items-center justify-center cursor-pointer"
                        onClick={() => {
                          setIsData((prevData) => ({
                            ...prevData,
                            booking: [...isData.booking, 1],
                          }))
                        }}
                      >
                        Add Another Car
                      </span>
                    )}
                  </div>

                  {/* Enter Name: */}
                  <div className="flex flex-col col-span- 2">
                    <span className="text-sm">
                      Enter Full Name:
                      <span className="text-red-500">*</span>
                    </span>
                    <input
                      type="text"
                      className="h-10 rounded-md px-2 text-black border border-black"
                      placeholder="Full Name"
                      required
                      value={isData.firstName}
                      name="firstName"
                      onChange={booking}
                    />
                  </div>
                  {/* Enter Email: */}
                  <div className="flex flex-col col-span-2">
                    <span className="text-sm">
                      Enter Email:
                      <span className="text-red-500">*</span>
                    </span>
                    <input
                      type="email"
                      className="h-10 rounded-md px-2 text-black border border-black"
                      placeholder="Enter Email"
                      value={isData.email}
                      name="email"
                      onChange={booking}
                    />
                    <div className="space-x-2">
                      <input
                        className="mt-1"
                        type="checkbox"
                        name="sendEmail"
                        id="sendEmail"
                        checked={isSendStatus.sendEmail}
                        onChange={(e) => {
                          setIsSendStatus((item) => ({
                            ...item,
                            sendEmail: e.target.checked,
                          }))
                        }}
                      />
                      <label htmlFor="sendEmail">Send Email?</label>
                    </div>
                  </div>
                  {/* Enter Phone Number: */}
                  <div className="flex flex-col col-span-2">
                    <span className="text-sm">
                      Enter Phone Number:
                      <span className="text-red-500">*</span>
                      {isPhoneLoading ? <span className="pl-5">Loading....</span> : null}
                    </span>
                    {/* <input
                      type="number"
                      className="h-10 rounded-md px-2 text-black border border-black"
                      placeholder="Ph.(+1 236-992-8610)"
                      value={isData.phoneNumber}
                      required
                      name="phoneNumber"
                      onChange={booking}
                    /> */}
                    <div className="h-11">
                      {/* <AutoCompleteComponent
                        id="phoneNumber"
                        dataSource={customerListData ?? []}
                        // sortOrder="Ascending"
                        placeholder="Ph.(+1 236-992-8610)"
                        value={isData.phoneNumber}
                        fields={customerFields ?? {}}
                        // showPopupButton={true}
                        highlight={true}
                        filterType={filterType}
                        popupHeight="250px"
                        suggestionCount={8}
                        onChange={onChange}
                        onClick={(e) => {
                          console.log(e)
                        }}
                        itemTemplate={itemTemplate}
                        // headerTemplate={headerTemplate}
                      /> */}
                      <Select
                        className={`border ${phoneInput.length === 10 || phoneInput.length === 0 ? "border-black" : "border-red-500"}`}
                        options={options}
                        value={selectedOption}
                        onChange={(e) => {
                          console.log("Selected:", e)
                          handleSelect(e)
                        }}
                        // inputValue={phoneInput}
                        onInputChange={(text, meta) => {
                          if (meta.action === "input-change") {
                            handleInputChange(text)
                          }
                        }}
                        isSearchable={true}
                        placeholder="Enter Phone Number"
                      />
                    </div>
                    <div className="space-x-2">
                      <input
                        className="mt-1"
                        type="checkbox"
                        name="sendSMS"
                        id="sendSMS"
                        checked={isSendStatus.sendSMS}
                        onChange={(e) => {
                          setIsSendStatus((item) => ({
                            ...item,
                            sendSMS: e.target.checked,
                          }))
                        }}
                      />
                      <label htmlFor="sendSMS">Send Msg?</label>
                    </div>
                  </div>
                  {/* Enter Address: */}
                  <div className="flex flex-col col-span-2">
                    {isData.locationType === "mobile" ? (
                      <>
                        <span className="text-sm">
                          Enter Address:
                          <span className="text-red-500">*</span>
                        </span>
                        <GoogleMap
                          onAddressSelect={handleAddressSelect}
                          data={isData.location}
                        />
                        {/* <input
                          type="text"
                          className="h-10 rounded-md px-2 text-black border border-black"
                          placeholder="Address"
                          value={isData.location}
                          name="location"
                          onChange={booking}
                          disabled={isData.locationType !== "mobile"}
                        /> */}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>

                  <div className="text-sm w-full col-span-5">
                    <div className="">
                      <p>Additional Details (Optional)</p>
                      <textarea
                        name="note"
                        id="note"
                        className="w-full border-2 p-2"
                        onChange={booking}
                      ></textarea>
                    </div>
                    <div>
                      <p>Admin Additional Details (Optional)</p>
                      <textarea
                        name="additionalNote"
                        id="additionalNote"
                        className="w-full border-2 p-2"
                        onChange={booking}
                      ></textarea>
                    </div>
                  </div>
                  {/* Button */}
                  <div className="flex col-span-7 space-x-5 justify-end">
                    <button
                      className="bg-gray-300 py-2 w-28 rounded shadow shadow-black"
                      onClick={onClick}
                    >
                      Cancel
                    </button>
                    {isEdit ? (
                      <>
                        <button
                          className="bg-yellow-medium_dark py-2 w-28 rounded shadow shadow-black"
                          type="submit"
                        >
                          Save
                        </button>
                        <button
                          className="bg-yellow-medium_dark py-2 w-28 rounded shadow shadow-black text-white"
                          type="button"
                          onClick={() => {
                            handleCreateBookingApi()
                          }}
                        >
                          Re-book
                        </button>
                      </>
                    ) : (
                      <button
                        className="bg-yellow-medium_dark py-2 w-28 rounded shadow shadow-black"
                        type="submit"
                      >
                        Create
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>

            {isLoading ? (
              <div className="absolute z-50 bg-black inset-0 bg-opacity-20 backdrop-blur-sm flex justify-center items-center text-white flex-col">
                <img src={Loader} alt="" className="size-14 object-cover" />
                <span>Loading...</span>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default CreateBooking
